import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routers from './routers'
Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)
import Meta from "vue-meta";
Vue.use(Meta);
Vue.use(VueRouter)
import VueResource from "vue-resource"
Vue.use(VueResource)
const router = new VueRouter({
  // mode: 'history',
  routes: routers
})


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


